import React, { useEffect, useState } from "react";
import { NavItem } from 'reactstrap';
import { Link } from 'react-router-dom';
import { GiHamburgerMenu } from "react-icons/gi";
import "./Menu.scss";
import { getUrl } from "../../../utils/urlLibrary";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPowerOff, faAngleDown, faInfo } from '@fortawesome/free-solid-svg-icons';
import { useDispatch } from "react-redux";
import { actions as usersActions } from '../../../reducers/users';
import { useSelector } from "react-redux";

const EXAM_MODE_INFO = {
  realizarExamenRapido: 'Examen configurable. Verás si cada respuesta es correcta o incorrecta justo después de contestar.',
  realizarExamenReal: 'Examen no configurable. No conocerás el resultado hasta que finalices el examen.',
  realizarExamenSimulacro: 'Examen configurable. No verás el resultado final hasta terminar el examen.',
  realizarExamenErroneas: 'Rehaz tus preguntas erróneas eligiendo el modo de examen y elimínalas de tu banco de erróneas.',
};

function Menu({ isMenuOpen, onToggle, onClose, menuContent }) {

  const dispatch = useDispatch();
  const authenticated = useSelector(state => state.users.authenticated);
  const authenticatedUserName = authenticated?.user || authenticated?.email || 'Usuario';
  const supportsHover = typeof window !== 'undefined'
    && window.matchMedia('(hover: hover) and (pointer: fine)').matches;
  const [openInfoKey, setOpenInfoKey] = useState(null);
  const visibleMenuContent = Array.isArray(menuContent)
    ? menuContent.filter(item => item?.urlKey !== 'foros')
    : [];

  const handleLogoutClick = () => {
    localStorage.setItem("logout", Date.now());
    dispatch(
      usersActions.makeLogout()
    );
    onClose();
  };

  const handleInfoToggle = (e, urlKey) => {
    e.preventDefault();
    e.stopPropagation();

    if (supportsHover) {
      return;
    }

    setOpenInfoKey((prevKey) => prevKey === urlKey ? null : urlKey);
  };

  useEffect(() => {
    if (supportsHover || !openInfoKey) {
      return undefined;
    }

    const handleOutsideClick = () => {
      setOpenInfoKey(null);
    };

    document.addEventListener('click', handleOutsideClick);

    return () => {
      document.removeEventListener('click', handleOutsideClick);
    };
  }, [openInfoKey, supportsHover]);
  
  return (
    <div className="Menu">
      <div className="menu-header">
        <button type="button" className="menu-header__toggle" onClick={onToggle} aria-label="Cerrar menú">
          <GiHamburgerMenu className="menu-btn" />
        </button>
        <div className="menu-header__copy">
          <span className="menu-header__title">PlayQir Pro</span>
        </div>
      </div>
      <div className="menu-section-label">Accesos</div>
      <div className="navbar-nav">
        {visibleMenuContent.length > 0 && visibleMenuContent.map(item => {
          if (Array.isArray(item.subItem) && item.subItem.length > 0) {
            return (
              <NavItem key={item.urlKey} className="menu-item menu-item--has-children">
                <div className="menu-item__parent">
                  <span className="menu-item__text">{item.name}</span>
                  <FontAwesomeIcon icon={faAngleDown} className="ml-2 rotateIcon" />
                </div>
                
                  {item.subItem.map(subItem => {
                    const { urlKey, name } = subItem;
                     const infoText = EXAM_MODE_INFO[urlKey];
                    return (
                      <NavItem key={urlKey} className="menu-subitem-wrapper">
                         <div className={`subNavItem hover-mouse ${openInfoKey === urlKey ? 'subNavItem--info-open' : ''}`}>
                           <Link className="subNavItem__link" to={getUrl(urlKey)} onClick={() => { setOpenInfoKey(null); onClose(); }}>{name}</Link>
                           {infoText && (
                             <div className="menu-subitem-info">
                               <button
                                 type="button"
                                 className="menu-subitem-info__button"
                                 aria-label={`Información sobre el modo ${name}`}
                                  aria-expanded={openInfoKey === urlKey}
                                  onClick={(e) => handleInfoToggle(e, urlKey)}
                               >
                                 <FontAwesomeIcon icon={faInfo} />
                               </button>
                             </div>
                           )}
                           {infoText && (
                             <div className="menu-subitem-info__tooltip" role="tooltip">
                               {infoText}
                             </div>
                           )}
                         </div>
                      </NavItem>
                    );
                  })}
                
              </NavItem>
            );
            } else {
              const { urlKey, name } = item;
              return (
                <NavItem key={urlKey} className="menu-item hover-mouse">
                  <Link to={getUrl(urlKey)} onClick={onClose}>{name}</Link>
                </NavItem>
              );
            }
        })}
      </div>
      <div className="menu-footer">
        <button type="button" className="logout-btn" onClick={handleLogoutClick}>
          <FontAwesomeIcon icon={faPowerOff} className="logout-icon" />
          <span>Cerrar sesión</span>
        </button>
        {authenticated && (
          <span className="user-header-menu">
            {authenticatedUserName}
          </span>
        )}
      </div>
    </div>
  );
}

export default Menu;
